export default { sha: '9d6cf4ea245721a1a81f9bdf5a03b9b34342dca1', buildNumber: 'undefined' }
